import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { LoadingButton, Text } from "@zillow/constellation";
import PropTypes from "prop-types";
import "react";
import { useFormState } from "react-hook-form";
const SimonFields = ({
  buttonText,
  children,
  legalText
}) => {
  const formStateProxy = useFormState();
  const formState = {
    isSubmitSuccessful: formStateProxy.isSubmitSuccessful
  };
  return !formState.isSubmitSuccessful ? /* @__PURE__ */ jsxs(Fragment, { children: [
    children,
    /* @__PURE__ */ jsx(LoadingButton, { type: "submit", buttonType: "primary", disabled: formState.isSubmitting, loading: formState.isSubmitting, children: buttonText }),
    /* @__PURE__ */ jsx(Text, { as: "p", fontType: "legal", marginTop: "md", children: legalText })
  ] }) : null;
};
SimonFields.propTypes = {
  children: PropTypes.node.isRequired,
  buttonText: PropTypes.string
};
SimonFields.defaultProps = {
  buttonText: "Subscribe",
  legalText: ""
};
export {
  SimonFields as default
};
